import React from "react";

import { Modal, Typography } from "components/Common/clearsense-ui/components";

const DetailsModal = ({ showModal, selectedRow, onModalClose }) => (
  <Modal
    isOpen={showModal}
    onClose={onModalClose}
    className="overflow-auto h-5/6"
    size="md"
    data-cy="result-modal"
  >
    <Modal.Body className="flex flex-col my-4 space-y-4">
      <Typography style="h3" className="flex justify-center">
        FHIR Conversion Data
      </Typography>
      <Typography style="h4" className="flex justify-left">
        <span className="font-semibold">Name: </span> {selectedRow.name}
      </Typography>
      <Typography style="h4" className="flex justify-left">
        <span className="font-semibold">Description: </span>{" "}
        {selectedRow.description}
      </Typography>
      <Typography style="h4" className="flex justify-left">
        <span className="font-semibold">Converter: </span>{" "}
        {selectedRow.conversion_type}
      </Typography>
      <Typography style="h4" className="flex justify-left">
        <span className="font-semibold">Data: </span> {selectedRow.data}
      </Typography>
      <Typography style="h4" className="flex justify-left">
        <span className="font-semibold">Result: </span>{" "}
        {JSON.stringify(selectedRow.response, null, 4)}
      </Typography>
    </Modal.Body>
  </Modal>
);

export default DetailsModal;
